/**
 * 快递报价设置 - 单对象 - 主子表表单联动
 * 1. 主-物流公司(fk).物流报价类型(.rowItem.ST_C_LOG_QUOT_TYPE_ID)：
 *  1.1. 根据(ST_C_LOG_QUOT_TYPE_ID)字段值（按国家、按省、按邮编[精准、模糊]）的不同,联动变更[快递报价设置明细]
 * 2. 注意 详情初始化/刷新、翻页 时 的处理
 */

export default {
  mounted() {
    window.addEventListener("notificationOfMain", ({ detail }) => {
      this.subLinkChange03(detail)
    }, false);

  },
  updated() {
    if (vm.$route.params.tableName == 'ST_C_EXPRESS_PRICE_STRATEGY') {
      this.initSubLinkChange03()
    }
  },
  watch: {
    currentPage(val) {
      this.subLinkChange03()
    },
  },
  computed: {
    currentPage() { // 监听表格翻页
      let page = 1
      if (vm.$route.params.tableName != 'ST_C_EXPRESS_PRICE_STRATEGY') return page
      let tabPanels = vm.$store.state[R3.getModuleName()].tabPanels
      let tab = tabPanels.find(i => i.tablename == 'ST_C_EXPRESS_PRICE_STRATEGY_ITEM')
      tab && (page = tab.tablePageInfo.currentPageIndex)
      return page
    }
  },
  methods: {
    async subLinkChange03(_detail) {
      if (vm.$route.params.tableName == 'ST_C_EXPRESS_PRICE_STRATEGY' && !vm.$route.fullPath.includes("/SYSTEM/TABLE/")) {
        let detail = _detail
        if (!detail) { // 详情初始化/刷新
          const page = vm.$store.state[R3.getModuleName()]
          const childs = page.copyDataForReadOnly.addcolums[0].childs
          // 调 queryList 拿到 ST_C_LOG_QUOT_TYPE_ID
          let id = childs.find(i => i.colname == "CP_C_LOGISTICS_ID").refobjid || ''
          if (id) {
            var formdata = new FormData();
            formdata.append('searchdata', JSON.stringify({ isdroplistsearch: true, refcolid: 1700839417, fixedcolumns: { ID: `=${id}` }, startindex: this.startindex, range: 10 }));
            await vm.service.common.QueryList(formdata).then(res => {
              const type = res.data.datas.row[0].ST_C_LOG_QUOT_TYPE_ID
              console.log('type::', type);
              if (type.refobjid != -1) {
                detail = {
                  item: {
                    colname: "CP_C_LOGISTICS_ID",
                    currentValue: [
                      {
                        rowItem: {
                          ST_C_LOG_QUOT_TYPE_ID: {
                            refobjid: type.refobjid,
                            val: type.val
                          }
                        }
                      }
                    ]
                  },
                  CP_C_LOGISTICS_ID: id
                }
              }
            });
          }
        }
        if (detail && detail.hasOwnProperty('CP_C_LOGISTICS_ID') && (detail.item && detail.item.colname == "CP_C_LOGISTICS_ID")) {
          /* if (detail.item && detail.item.colname == "CP_C_LOGISTICS_ID") {
            detail = {
              CP_C_LOGISTICS_ID: detail.item.currentValue[0].rowItem.ST_C_LOG_QUOT_TYPE_ID.refobjid
            }
          } */
          const val = detail.item.currentValue[0].rowItem.ST_C_LOG_QUOT_TYPE_ID.val
          console.log('快递报价设置-主子表联动::', detail);
          const page = vm.$store.state[R3.getModuleName()]
          const nowTabForm = _.cloneDeep(page.tabPanels[page.tabCurrentIndex].componentAttribute.formData.data.inpubobj)
          const nowTabTable= _.cloneDeep(page.tabPanels[page.tabCurrentIndex].componentAttribute.tableData.data)
          let newData = {
            tabIndex: page.tabCurrentIndex,
            inpubobj: nowTabForm
          }
          let doArr = []
          try {
            switch (val) {
              case '国家':
              case '按国家': // 隐藏'省份'、'邮编'
                doArr = ["PROVINCE_ID", "ZIP"]
                break;
              case '省':
              case '省份':
              case '按省份':
              case '按省': // 隐藏'国家'、'邮编'
                doArr = ["CP_C_COUNTRY_ID", "ZIP"]
                break;
              case '邮编':
              case '按邮编': // 隐藏'国家'、'省份'
                doArr = ["CP_C_COUNTRY_ID", "PROVINCE_ID"]
                break;
              default:
                nowTabForm.forEach((it, dex) => {
                  it.show = true // 框架使用的属性,涉及计算grid
                });
                if (nowTabTable && nowTabTable.tabth) {
                  nowTabTable.tabth.forEach((it, dex) => {
                    it.hide = false
                    it.isfilter = it.hasOwnProperty('_isfilter') ? !it._isfilter : it.isfilter
                  });
                }
                break;
            }
            // 初始状态
            nowTabForm.forEach((it, dex) => {
              it.show = true
            });
            if (nowTabTable && nowTabTable.tabth) {
              nowTabTable.tabth.forEach((it, dex) => {
                it.hide = false
                it.isfilter = it.hasOwnProperty('_isfilter') ? !it._isfilter : it.isfilter
              });
            }
            // 联动
            nowTabForm.forEach((it, dex) => {
              if (doArr.includes(it.colname)) {
                it.show = false
              }
            });
            newData = {
              tabIndex: page.tabCurrentIndex,
              inpubobj: nowTabForm
            }
            nowTabTable.tabth.forEach((it, dex) => {
              if (doArr.includes(it.colname)) {
                it.hide = true
                it.isfilter = false
                it._isfilter = false // 标识被调整过
              }
            });
            $store.commit(`${R3.getModuleName()}/updateFormDataForRefTable`, newData) // 更新子表-表单
            $store.commit(`${R3.getModuleName()}/updateTableListForRefTable`, nowTabTable) // 更新子表-表格
          } catch (e) {
            console.log(e);
          }
        }
      }
    },
    initSubLinkChange03: _.debounce(function() {
      this.subLinkChange03()
    }, 1200)
  }
}
